import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from '../Button';
import './index.css';
import AngleUpIcon from '../../assets/images/angle-up.svg';
import AngleDownIcon from '../../assets/images/angle-down.svg';


class TrustedContactInfoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  onToggle = () => {
    this.setState({
      visible: !this.state.visible,
    });
    return false;
  };

  render() {
    const MESSAGE = 'A Trusted Contact Person (“TCP”) is someone that you tell us we can contact if we have questions about your well-being. By providing this information, you authorize us to contact the TCP and disclose information about you in order to confirm the specifics of your current contact information, health status and inquire if another person or entity has legal authority to act on your behalf (such as legal guardian, executor, trustee or holder of a power of attorney). The TCP must be at least 18 years old and will not have the ability to transact on your account.';
    return (
      <div styleName={`trustedContactInfo ${this.props.centered ? 'trustedContactInfoCentered' : ''}`}>
        <Button type="button" onClick={() => this.onToggle()} className="btnSecondary">
          {
            this.state.visible ?
              <img styleName="trustedContactInfoArrow" height="8" src={AngleUpIcon} alt="show up icon" /> :
              <img styleName="trustedContactInfoArrow" height="8" src={AngleDownIcon} alt="show down icon" />
          }
          <span>What is a Trusted Contact Person?</span>
        </Button>
        {
          this.state.visible ?
            <div styleName="trustedContactInfoMessage" style={{ fontSize: this.props.fontSize || '12px' }}>
              {MESSAGE}
            </div> : null
        }
        {
          this.props.bottomBorder ? <div styleName="tcDivider" /> : null
        }
      </div>
    );
  }
}

const mapStateToProps = () => ({

});

const mapDispatchToProps = () => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(TrustedContactInfoContainer);



// WEBPACK FOOTER //
// ./src/components/TrustedContactInfo/index.js